import { sparql } from '@tpluscode/rdf-string';
import { concat } from "../TemplateResult.mjs";
export default (() => ({
  havings: null,

  havingClause() {
    if (this.havings) {
      return sparql`HAVING ${this.havings}`;
    }

    return sparql``;
  },

  HAVING(strings, ...values) {
    return { ...this,
      havings: concat(this.havings, strings, values, true)
    };
  }

}));